export default "__VITE_ASSET__5bf4c190__"